/**
 * A dictionary with all the module custom events.
 * @type {AuthEvents}
 * @ngesdoc constant
 * @ngname AUTH_EVENTS
 * @ngmodule auth
 */
const authRoutes = {
  unauthorized: 'app/modules/auth/unauthorized',
};

export default authRoutes;
